import React, { useCallback, useEffect, useState } from 'react'
import { useRecoilValue } from 'recoil'
import { clinicState } from '../../../globalState';
import Button from '../../forms/Button/Button';
import styles from './WelcomePage.module.scss'
import Background from '../../Background/Background';
import { useLocation, useParams } from 'react-router-dom';
import { LunaJoyFoundationService } from '../../../services/LunajoyFoundationService';
import Loader from '../../Loader/Loader';
import { PARTNER_LANDING_URL } from '../../../utilities/urls';

const WelcomePage = ({ setCurrentPage }) => {
    const location = useLocation();
    const { slug } = useParams()
    const [loading, setLoading] = useState(false)
    const { clinic } = useRecoilValue(clinicState);
    const queryParams = new URLSearchParams(location.search);
    const contact_id = queryParams.get('contactId');
    const email = queryParams.get('email')

    const handleClick = () => {
        setCurrentPage('personal-information')
    }

    const redirectToPartnerLandingPage = useCallback(async () => {
        try {
            if (window.location.pathname.includes(`screening/${slug}`) && !contact_id && !email) {
                setLoading(true)
                const clinicInfo = await LunaJoyFoundationService.getClinicBySlug(slug)

                // check if the clinicInfo is null and if it is, then redirect to the partner landing page   
                // location.assign, not window.open(..., "_self", "noopener"): Safari opens
                // "noopener" in a new window, which its popup blocker drops here
                window.location.assign(clinicInfo?.landingPageUrl || PARTNER_LANDING_URL)
            } else if (!contact_id && !email) {
                setLoading(true)
                window.location.assign(PARTNER_LANDING_URL)
            }
        } catch (error) {
            setLoading(false)
            console.error("Error in redirectToPartnerLandingPage - ", error)
        }
    }, [slug])

    useEffect(() => {
        redirectToPartnerLandingPage()
    }, [redirectToPartnerLandingPage])


    return <>
        {loading ? <Loader /> : <Background clinicDetails={clinic} >
            <div className={styles.container}>
                <h1 className={styles.heading}>Welcome to the Mental Well-being Assessment!</h1>
                <div className={styles.contents}>
                    <div className={styles.forms}>
                        <p className={styles.para}>This confidential and interactive tool is crafted to evaluate your emotional health</p>
                        <div className={styles.buttonContainer}>
                            <Button type="button" onClick={handleClick}>Take Assessment</Button>
                        </div>
                    </div>
                </div>
            </div>
        </Background>}
    </>

};

export default WelcomePage
